import React from "react"
import { cn } from "../../styles/utils"
import { Box } from "../gluestack/box"

type MobileLayoutProps = {
  children: React.ReactNode
  className?: string
}

export const MobileLayout: React.FC<MobileLayoutProps> = ({
  children,
  className,
}) => {
  return <Box className={cn("flex-1", className)}>{children}</Box>
}
